import { Anchored, Button, Spacer, Text } from "@vericus/cadmus-ui";

import errorIllustration from "@/assets/illustrations/man-lost-with-map.png";

import { Actions, Grid, GridContent, GridImg } from "./styles";

/**
 * Full page API error page displayed to the user. This type of error is
 * irrecoverable and needs a refresh. Also displayes links to Cadmus user
 * support.
 */
export function ApiError() {
  return (
    <Grid>
      <GridImg
        style={{ maxWidth: 360 }}
        src={errorIllustration}
        alt="Illustration of a man looking confused whilst holding a map with a university building in the background"
      />
      <GridContent>
        <Text kind="displayTwo">Cannot reach Cadmus</Text>
        <Text kind="lead">
          This is usually due to a drop in internet connection. Try refreshing
          the page. If that doesn’t work, Cadmus may temporarily be down.
        </Text>
        <Spacer spacing={27} />
        <Actions>
          <Anchored
            newTab
            href="https://support.cadmus.io/students/cannot-reach-cadmus"
          >
            <Button kind="secondary">Learn more about this error</Button>
          </Anchored>
          <Anchored newTab href="https://support.cadmus.io/kb-tickets/new">
            <Button>Contact us for help</Button>
          </Anchored>
        </Actions>
        <Spacer spacing={72} />
      </GridContent>
    </Grid>
  );
}
